// Searchable, business-oriented emoji dataset for the topic icon picker.
// Each entry has the emoji plus lowercase keywords used by the picker search.
// Expanded set (~3x). Duplicates are filtered at render time.
const E = (emoji, ...keywords) => ({ emoji, keywords });

export const businessEmojis = [
  // ===== COMMUNICATION & CONTACT =====
  E("📞", "phone", "call", "telephone", "contact"),
  E("☎️", "telephone", "phone", "landline", "contact"),
  E("📱", "mobile", "phone", "iphone", "cell", "smartphone"),
  E("📲", "call", "mobile", "incoming", "phone"),
  E("✉️", "email", "envelope", "mail", "letter"),
  E("📧", "email", "e-mail", "mail"),
  E("📨", "incoming", "envelope", "email", "message"),
  E("📩", "envelope", "email", "send", "arrow"),
  E("📤", "outbox", "send", "outgoing", "upload"),
  E("📥", "inbox", "receive", "incoming", "download"),
  E("📮", "postbox", "mail", "post", "letterbox"),
  E("📫", "mailbox", "mail", "letter"),
  E("📪", "mailbox", "closed", "mail"),
  E("📬", "mailbox", "mail", "new"),
  E("📭", "mailbox", "empty", "mail"),
  E("💬", "chat", "message", "speech", "talk", "comment"),
  E("💭", "thought", "think", "idea", "bubble"),
  E("🗨️", "speech", "comment", "chat", "talk"),
  E("🗯️", "anger", "speech", "burst", "shout"),
  E("📢", "announcement", "loudspeaker", "megaphone", "broadcast", "marketing"),
  E("📣", "megaphone", "announce", "cheer", "promote"),
  E("🔔", "bell", "notification", "alert", "reminder"),
  E("🔕", "mute", "silent", "no bell", "quiet"),
  E("🗣️", "speak", "talk", "voice", "announce"),
  E("📻", "radio", "broadcast", "audio", "news"),
  E("📡", "satellite", "antenna", "signal", "broadcast", "network"),
  E("🎙️", "microphone", "studio", "podcast", "record", "voice"),
  E("🎤", "microphone", "speak", "present", "audio", "voice"),
  E("🎧", "headphones", "audio", "listen", "support"),
  E("📟", "pager", "beeper", "message", "alert"),
  E("📠", "fax", "machine", "document", "office"),
  E("🔊", "speaker", "volume", "sound", "loud", "audio"),
  E("🔉", "speaker", "volume", "sound", "audio"),
  E("🔈", "speaker", "volume", "quiet", "audio"),
  E("🔇", "mute", "silent", "speaker", "off"),
  E("📯", "postal horn", "announce", "horn", "mail"),

  // ===== OFFICE & DOCUMENTS =====
  E("💼", "briefcase", "work", "business", "job", "portfolio"),
  E("📁", "folder", "file", "directory", "documents"),
  E("📂", "open folder", "file", "documents"),
  E("🗂️", "card index", "dividers", "organize", "files"),
  E("🗃️", "card file", "box", "archive", "files"),
  E("🗄️", "file cabinet", "storage", "archive", "drawer", "database"),
  E("📄", "page", "document", "file", "paper"),
  E("📃", "page", "curl", "document", "paper"),
  E("📑", "bookmark tabs", "document", "pages", "tabs"),
  E("📜", "scroll", "document", "certificate", "paper"),
  E("📰", "newspaper", "news", "press", "article"),
  E("🗞️", "newspaper", "news", "press", "rolled"),
  E("📋", "clipboard", "list", "notes", "checklist"),
  E("📝", "memo", "note", "write", "edit", "pencil"),
  E("✏️", "pencil", "write", "edit", "draw"),
  E("✒️", "pen", "nib", "write", "sign"),
  E("🖊️", "pen", "write", "ballpoint"),
  E("🖋️", "fountain pen", "write", "sign", "signature"),
  E("🖌️", "paintbrush", "art", "paint", "design"),
  E("🖍️", "crayon", "draw", "color"),
  E("🔖", "bookmark", "tag", "save", "mark"),
  E("🏷️", "label", "tag", "price", "badge"),
  E("📎", "paperclip", "attach", "attachment"),
  E("🖇️", "paperclips", "attach", "link"),
  E("📌", "pushpin", "pin", "location", "mark"),
  E("📍", "pin", "location", "map", "marker"),
  E("✂️", "scissors", "cut", "edit"),
  E("🖨️", "printer", "print", "office"),
  E("🖥️", "desktop", "computer", "monitor", "screen"),
  E("💻", "laptop", "computer", "work", "code"),
  E("⌨️", "keyboard", "type", "typing", "input"),
  E("🖱️", "mouse", "click", "computer"),
  E("🗑️", "trash", "delete", "bin", "remove"),
  E("🔒", "lock", "secure", "private", "closed"),
  E("🔓", "unlock", "open", "unsecure"),
  E("🔐", "lock", "key", "secure", "closed", "encryption", "auth"),
  E("🔑", "key", "access", "unlock", "password"),
  E("🗝️", "key", "old key", "access"),
  E("🔏", "lock", "pen", "signature", "secure"),
  E("🖨️", "printer", "print", "office", "paper"),
  E("🗳️", "ballot", "vote", "box", "election"),
  E("📇", "card index", "rolodex", "contacts", "directory"),
  E("🗃️", "archive", "file box", "storage", "records"),
  E("🖼️", "picture", "frame", "image", "art"),
  E("✉️", "envelope", "letter", "mail"),
  E("🧾", "receipt", "invoice", "bill", "payment"),

  // ===== ANALYTICS & FINANCE =====
  E("📊", "bar chart", "chart", "stats", "analytics", "data"),
  E("📈", "chart up", "growth", "increase", "trend", "profit", "analytics"),
  E("📉", "chart down", "decrease", "loss", "decline", "trend"),
  E("💹", "yen", "chart", "market", "stocks", "trend"),
  E("💱", "currency exchange", "forex", "money", "exchange"),
  E("💲", "dollar", "money", "price", "cost"),
  E("💰", "money bag", "money", "wealth", "profit", "budget"),
  E("💵", "dollar", "cash", "money", "payment"),
  E("💴", "yen", "cash", "money"),
  E("💶", "euro", "cash", "money"),
  E("💷", "pound", "cash", "money"),
  E("💳", "credit card", "payment", "card", "pay"),
  E("💸", "money with wings", "spend", "expense", "cash"),
  E("🪙", "coin", "money", "token", "crypto", "currency"),
  E("⚖️", "balance", "scale", "justice", "legal", "compare"),
  E("🧮", "abacus", "calculate", "math", "accounting"),
  E("🖩", "calculator", "math", "accounting", "numbers", "calculate"),
  E("🪪", "id card", "identity", "badge", "identification"),
  E("🏦", "bank", "finance", "money", "institution"),
  E("🏧", "atm", "cash", "money", "withdraw"),
  E("💎", "gem", "diamond", "value", "premium", "wealth"),
  E("🪙", "coin", "gold", "money"),
  E("📠", "fax", "finance", "document"),
  E("🧾", "receipt", "expense", "invoice", "bill"),
  E("💰", "moneybag", "profit", "revenue", "earnings"),
  E("🪙", "token", "crypto", "coin"),
  E("📊", "analytics", "metrics", "kpi", "report"),
  E("🧾", "ledger", "accounting", "receipt"),

  // ===== TIME & PLANNING =====
  E("📅", "calendar", "date", "schedule", "event"),
  E("📆", "calendar", "tear off", "date", "day"),
  E("🗓️", "spiral calendar", "calendar", "schedule", "planner"),
  E("🗒️", "notepad", "notes", "memo", "spiral"),
  E("⏰", "alarm", "clock", "reminder", "morning"),
  E("🕰️", "mantel clock", "clock", "time"),
  E("⏱️", "stopwatch", "timer", "time", "track"),
  E("⏲️", "timer", "clock", "countdown"),
  E("⌛", "hourglass", "time", "waiting", "deadline"),
  E("⏳", "hourglass", "flowing", "time", "deadline"),
  E("🕐", "clock", "one", "time", "hour"),
  E("🕑", "clock", "two", "time"),
  E("🕒", "clock", "three", "time"),
  E("🕓", "clock", "four", "time"),
  E("🕔", "clock", "five", "time"),
  E("🕕", "clock", "six", "time"),
  E("🕖", "clock", "seven", "time"),
  E("🕗", "clock", "eight", "time"),
  E("🕘", "clock", "nine", "time"),
  E("🕙", "clock", "ten", "time"),
  E("🕚", "clock", "eleven", "time"),
  E("🕛", "clock", "twelve", "time"),
  E("⌚", "watch", "time", "wrist"),
  E("🕐", "one oclock", "clock", "time"),
  E("⏳", "hourglass", "deadline", "countdown"),
  E("🗓️", "planner", "calendar", "schedule", "agenda"),

  // ===== TOOLS & IDEAS =====
  E("💡", "idea", "light bulb", "innovation", "tip", "solution"),
  E("🔍", "search", "find", "magnifier", "lookup", "investigate"),
  E("🔎", "search", "find", "magnifier right", "lookup"),
  E("🔬", "microscope", "science", "research", "lab", "analysis"),
  E("🔭", "telescope", "vision", "forecast", "explore"),
  E("🧪", "test tube", "experiment", "lab", "science", "test"),
  E("⚗️", "alembic", "chemistry", "experiment", "science"),
  E("🧬", "dna", "genetics", "science", "biology"),
  E("🧲", "magnet", "attract", "lead", "attraction"),
  E("🔧", "wrench", "tool", "fix", "repair", "settings"),
  E("🔨", "hammer", "tool", "build", "fix"),
  E("🛠️", "hammer wrench", "tools", "build", "settings", "fix"),
  E("⚙️", "gear", "settings", "configuration", "cog", "process"),
  E("🗜️", "clamp", "compress", "tool", "vice"),
  E("🔩", "nut and bolt", "hardware", "build", "screw"),
  E("🔗", "link", "chain", "connect", "url", "integration"),
  E("⛓️", "chains", "link", "connect", "blockchain"),
  E("🧰", "toolbox", "tools", "kit", "repair"),
  E("🪜", "ladder", "climb", "steps", "progress", "growth"),
  E("🧭", "compass", "direction", "navigate", "guide", "strategy"),
  E("🪛", "screwdriver", "tool", "fix", "repair"),
  E("🪓", "axe", "chop", "cut", "tool"),
  E("⛏️", "pick", "mine", "dig", "tool"),
  E("⚒️", "hammer pick", "tools", "build", "mine"),
  E("🗡️", "dagger", "knife", "blade"),
  E("⚔️", "swords", "crossed", "battle", "fight"),
  E("🛡️", "shield", "security", "protect", "defense", "safety"),
  E("🧯", "fire extinguisher", "safety", "emergency"),
  E("🪤", "mouse trap", "trap", "catch"),
  E("🔦", "flashlight", "torch", "light", "search"),
  E("🕯️", "candle", "light", "flame"),
  E("💡", "lightbulb", "idea", "bright", "innovation"),
  E("🔆", "brightness", "high", "light", "sun"),
  E("🔅", "brightness", "low", "dim", "light"),

  // ===== PEOPLE & WORK =====
  E("🤝", "handshake", "deal", "agreement", "partnership", "contract"),
  E("👥", "people", "team", "group", "users", "customers"),
  E("👤", "person", "user", "profile", "account", "customer"),
  E("🧑‍💼", "office worker", "business", "professional", "employee", "manager"),
  E("👔", "tie", "business", "professional", "suit"),
  E("🧑‍💻", "technologist", "developer", "coder", "programmer", "it"),
  E("🧑‍🏫", "teacher", "trainer", "instructor", "coach", "educator"),
  E("🧑‍🔬", "scientist", "researcher", "lab", "analyst"),
  E("🧑‍⚖️", "judge", "legal", "law", "compliance", "court"),
  E("🧑‍⚕️", "health worker", "doctor", "medical", "healthcare"),
  E("🧑‍🔧", "mechanic", "technician", "repair", "engineer"),
  E("🧑‍🏭", "factory worker", "manufacturing", "industry", "operator"),
  E("🧑‍🚀", "astronaut", "space", "launch", "explorer"),
  E("🧑‍🎨", "artist", "designer", "creative", "design"),
  E("🧑‍🍳", "chef", "cook", "kitchen", "food"),
  E("🧑‍🌾", "farmer", "agriculture", "farm", "grower"),
  E("🕵️", "detective", "investigate", "spy", "inspect"),
  E("💂", "guard", "security", "protect", "sentry"),
  E("👷", "construction worker", "builder", "engineer", "hard hat"),
  E("🤵", "person in tuxedo", "formal", "business", "suit", "professional"),
  E("👑", "crown", "king", "leader", "royal", "premium"),
  E("🎓", "graduation", "education", "learning", "training", "degree"),
  E("👍", "thumbs up", "approve", "like", "yes", "good"),
  E("👎", "thumbs down", "disapprove", "no", "bad"),
  E("👏", "clap", "applause", "congrats", "bravo"),
  E("🙌", "raise hands", "celebrate", "hooray", "success"),
  E("🙏", "pray", "thanks", "please", "gratitude", "hope"),
  E("👋", "wave", "hello", "goodbye", "greeting", "hi"),
  E("✋", "raised hand", "stop", "high five", "halt"),
  E("🖐️", "hand", "fingers", "stop", "five"),
  E("✌️", "victory", "peace", "win", "two"),
  E("🤞", "crossed fingers", "luck", "hope", "wish"),
  E("👌", "ok", "okay", "perfect", "fine"),
  E("🤌", "pinched fingers", "chef kiss", "italian", "perfect"),
  E("🤏", "pinching", "small", "little", "tiny"),
  E("💪", "muscle", "strong", "flex", "strength", "power"),
  E("🖖", "vulcan", "spock", "greeting", "live long"),
  E("👊", "fist", "bump", "punch", "power"),
  E("✊", "raised fist", "power", "solidarity", "strong"),
  E("🤛", "left fist", "bump", "fist"),
  E("🤜", "right fist", "bump", "fist"),

  // ===== STATUS & FEEDBACK =====
  E("⭐", "star", "favorite", "rating", "important"),
  E("🌟", "glowing star", "star", "excellent", "featured"),
  E("✨", "sparkles", "new", "shiny", "magic", "special"),
  E("💫", "dizzy", "star", "sparkle", "shooting"),
  E("🏆", "trophy", "win", "award", "achievement", "winner"),
  E("🥇", "gold medal", "first", "winner", "best", "top"),
  E("🥈", "silver medal", "second", "runner up"),
  E("🥉", "bronze medal", "third", "place"),
  E("🏅", "medal", "award", "achievement", "sports"),
  E("🎖️", "military medal", "honor", "award", "badge"),
  E("🎯", "target", "goal", "dart", "objective", "aim", "focus"),
  E("✅", "check", "done", "complete", "success", "approved", "tick"),
  E("✔️", "check mark", "done", "yes", "confirm", "tick"),
  E("❌", "cross", "no", "error", "remove", "cancel"),
  E("❎", "cross mark", "no", "cancel", "button"),
  E("⚠️", "warning", "alert", "caution", "attention"),
  E("ℹ️", "info", "information", "details", "about"),
  E("❗", "exclamation", "important", "alert", "warning"),
  E("❓", "question", "help", "query", "support", "ask"),
  E("❔", "white question", "help", "query"),
  E("‼️", "double exclamation", "urgent", "alert"),
  E("⁉️", "exclamation question", "confused", "alert"),
  E("🚫", "prohibited", "no", "forbidden", "blocked", "denied"),
  E("⛔", "no entry", "stop", "forbidden", "blocked"),
  E("🔞", "no one under eighteen", "adult", "restricted"),
  E("🆗", "ok", "okay", "button", "accept"),
  E("🆕", "new", "button", "fresh", "recent"),
  E("🆒", "cool", "button", "approve"),
  E("🆓", "free", "button", "no cost"),
  E("🆙", "up", "button", "increase"),
  E("🔝", "top", "arrow", "best", "up"),
  E("🔛", "on", "arrow", "active"),
  E("🔜", "soon", "arrow", "coming"),
  E("🔚", "end", "arrow", "finish"),
  E("🔙", "back", "arrow", "return"),
  E("➕", "plus", "add", "new", "create"),
  E("➖", "minus", "subtract", "remove"),
  E("✖️", "multiply", "times", "close", "x"),
  E("➗", "divide", "division", "math"),
  E("💯", "hundred", "100", "perfect", "score", "full"),
  E("🔥", "fire", "hot", "trending", "popular", "lit"),
  E("⚡", "lightning", "fast", "electric", "power", "speed", "zap"),
  E("💥", "boom", "explosion", "collision", "burst", "impact"),

  // ===== TECH & DATA =====
  E("🤖", "robot", "bot", "ai", "automation", "agent"),
  E("🧠", "brain", "intelligence", "ai", "smart", "thinking"),
  E("👾", "space invader", "game", "alien", "retro", "arcade"),
  E("🎮", "video game", "controller", "gaming", "play"),
  E("🕹️", "joystick", "game", "control", "arcade"),
  E("💾", "floppy disk", "save", "storage", "data"),
  E("💿", "cd", "disc", "optical", "storage"),
  E("📀", "dvd", "disc", "storage"),
  E("💽", "minidisc", "storage", "disc", "data"),
  E("☁️", "cloud", "storage", "saas", "hosting"),
  E("🌐", "globe", "web", "internet", "network", "worldwide"),
  E("🌎", "earth", "americas", "globe", "world"),
  E("🌍", "earth", "europe", "africa", "globe", "world"),
  E("🌏", "earth", "asia", "australia", "globe", "world"),
  E("🔌", "plug", "electric", "power", "connect", "integration"),
  E("🔋", "battery", "power", "charge", "energy"),
  E("🪫", "low battery", "power", "empty", "charge"),
  E("🖲️", "trackball", "control", "input"),
  E("🎛️", "control knobs", "settings", "tune", "adjust"),
  E("🎚️", "level slider", "adjust", "settings", "control"),
  E("🧩", "puzzle", "piece", "plugin", "integration", "component"),
  E("🖥️", "computer", "desktop", "monitor", "screen", "workstation"),
  E("🖨️", "printer", "office", "print"),
  E("📠", "fax", "machine", "office"),
  E("🎥", "movie camera", "video", "record", "film"),
  E("📹", "video camera", "record", "video"),
  E("📷", "camera", "photo", "picture", "image"),
  E("📸", "camera flash", "photo", "picture"),
  E("📺", "tv", "television", "screen", "monitor"),
  E("📼", "vhs", "video", "tape", "cassette"),
  E("🔋", "battery", "energy", "power"),
  E("🧲", "magnet", "attract", "magnetic"),
  E("⚗️", "alembic", "lab", "science"),
  E("🧪", "test tube", "lab", "science", "experiment"),
  E("🧫", "petri dish", "lab", "science", "culture"),
  E("🧬", "dna", "genetics", "helix", "science"),
  E("🦠", "microbe", "virus", "bacteria", "germ"),
  E("💉", "syringe", "injection", "vaccine", "medical"),
  E("🩸", "blood", "drop", "medical"),
  E("💊", "pill", "medicine", "drug", "health"),
  E("🩹", "bandage", "bandaid", "heal", "medical"),
  E("🩺", "stethoscope", "doctor", "medical", "health"),

  // ===== LOGISTICS & OPERATIONS =====
  E("📦", "package", "box", "delivery", "shipping", "parcel"),
  E("🚚", "truck", "delivery", "shipping", "logistics", "transport"),
  E("🚀", "rocket", "launch", "deploy", "startup", "fast", "growth"),
  E("✈️", "airplane", "travel", "flight", "shipping", "logistics"),
  E("🛫", "airplane departure", "takeoff", "flight", "travel"),
  E("🛬", "airplane arrival", "landing", "flight", "travel"),
  E("🚁", "helicopter", "fly", "transport", "air"),
  E("⛵", "sailboat", "boat", "sail", "water"),
  E("🚢", "ship", "boat", "cargo", "shipping", "sea"),
  E("🚗", "car", "automobile", "drive", "vehicle", "transport"),
  E("🚕", "taxi", "cab", "transport", "ride"),
  E("🚙", "suv", "car", "vehicle", "drive"),
  E("🚌", "bus", "transport", "public", "transit"),
  E("🚎", "trolleybus", "transport", "transit"),
  E("🏎️", "race car", "fast", "speed", "racing"),
  E("🚓", "police car", "cop", "law", "enforcement"),
  E("🚑", "ambulance", "emergency", "medical", "health"),
  E("🚒", "fire engine", "emergency", "fire", "truck"),
  E("🚐", "minibus", "van", "transport"),
  E("🛻", "pickup truck", "truck", "transport", "utility"),
  E("🚜", "tractor", "farm", "agriculture", "vehicle"),
  E("🏍️", "motorcycle", "bike", "motorbike", "ride"),
  E("🛵", "scooter", "moped", "ride", "transport"),
  E("🚲", "bicycle", "bike", "cycle", "ride"),
  E("🛴", "kick scooter", "scooter", "ride"),
  E("🚂", "locomotive", "train", "rail", "transport"),
  E("🚆", "train", "rail", "transport", "transit"),
  E("🚇", "metro", "subway", "underground", "transit"),
  E("🚈", "light rail", "train", "transit"),
  E("🚝", "monorail", "train", "transit"),
  E("🏭", "factory", "manufacturing", "industry", "production"),
  E("🏢", "office building", "company", "corporate", "hq"),
  E("🏬", "department store", "retail", "shop", "store"),
  E("🏪", "convenience store", "shop", "retail", "store"),
  E("🏣", "japanese post office", "post", "mail", "office"),
  E("🏤", "post office", "mail", "european", "building"),
  E("🏥", "hospital", "medical", "health", "clinic"),
  E("🏨", "hotel", "accommodation", "stay", "travel"),
  E("🏩", "love hotel", "hotel", "building"),
  E("🏫", "school", "education", "building", "learning"),
  E("🏛️", "classical building", "government", "museum", "institution"),
  E("⛪", "church", "building", "worship", "religion"),
  E("🕌", "mosque", "building", "worship", "religion"),
  E("🛕", "hindu temple", "temple", "worship", "religion"),
  E("🕍", "synagogue", "building", "worship", "religion"),
  E("🏗️", "construction", "building", "crane", "development"),
  E("🧱", "brick", "build", "wall", "construction"),
  E("🪨", "rock", "stone", "boulder"),
  E("🛒", "shopping cart", "cart", "ecommerce", "buy", "purchase"),
  E("🛍️", "shopping bags", "shopping", "retail", "purchase"),
  E("🗺️", "map", "world map", "route", "plan", "geography"),
  E("🧭", "compass", "navigation", "direction", "explore"),
  E("⛽", "fuel", "gas", "pump", "petrol"),
  E("🚧", "construction", "barrier", "work in progress", "warning"),
  E("⚓", "anchor", "ship", "sea", "stable", "marine"),
  E("🪝", "hook", "catch", "grab", "lift"),
  E("🧳", "luggage", "suitcase", "travel", "baggage"),
  E("🛄", "baggage claim", "luggage", "airport", "travel"),
  E("🛃", "customs", "border", "control", "airport"),

  // ===== GENERAL OBJECTS & SYMBOLS =====
  E("🎁", "gift", "present", "reward", "bonus"),
  E("🎉", "party", "celebrate", "tada", "congrats", "success"),
  E("🎊", "confetti", "celebrate", "party", "success"),
  E("🎈", "balloon", "celebrate", "party"),
  E("🎀", "ribbon", "bow", "gift", "decoration"),
  E("🎗️", "reminder ribbon", "awareness", "ribbon", "cause"),
  E("🏵️", "rosette", "award", "prize", "flower"),
  E("🎫", "ticket", "admission", "event", "pass"),
  E("🎟️", "admission tickets", "ticket", "event"),
  E("🎪", "circus", "tent", "event", "show"),
  E("🎭", "performing arts", "theater", "masks", "drama"),
  E("🎨", "art", "palette", "paint", "creative", "design"),
  E("🎬", "clapper", "movie", "film", "action"),
  E("🎼", "musical score", "music", "notes", "sheet"),
  E("🎵", "musical note", "music", "song", "melody"),
  E("🎶", "musical notes", "music", "song", "melody"),
  E("🎹", "musical keyboard", "piano", "music", "keys"),
  E("🎸", "guitar", "music", "rock", "instrument"),
  E("🎻", "violin", "music", "instrument", "classical"),
  E("🎺", "trumpet", "music", "instrument", "brass"),
  E("🎷", "saxophone", "music", "jazz", "instrument"),
  E("🥁", "drum", "music", "beat", "percussion"),
  E("☕", "coffee", "break", "meeting", "drink"),
  E("🍵", "tea", "drink", "break"),
  E("🧃", "juice box", "drink", "beverage"),
  E("🥤", "cup with straw", "drink", "beverage", "soda"),
  E("🧋", "bubble tea", "boba", "drink", "tea"),
  E("🍺", "beer", "drink", "mug"),
  E("🍻", "beers", "cheers", "toast", "celebrate"),
  E("🍷", "wine", "glass", "drink"),
  E("🥂", "champagne", "toast", "celebrate", "cheers"),
  E("🍸", "cocktail", "drink", "martini"),
  E("🍹", "tropical drink", "cocktail", "drink", "vacation"),
  E("🧊", "ice", "cube", "cold", "frozen"),
  E("🎓", "graduation", "cap", "education", "degree", "learning"),
  E("📚", "books", "library", "learning", "knowledge", "docs"),
  E("📖", "book", "read", "open book", "documentation", "manual"),
  E("📓", "notebook", "notes", "journal"),
  E("📔", "notebook", "decorative", "notes", "cover"),
  E("📒", "ledger", "notebook", "accounts", "records"),
  E("📕", "closed book", "book", "red"),
  E("📗", "green book", "book"),
  E("📘", "blue book", "book"),
  E("📙", "orange book", "book"),
  E("🔖", "bookmark", "save", "mark", "tag"),
  E("🧷", "safety pin", "pin", "attach"),
  E("🎍", "bamboo", "decoration", "pine", "japanese"),
  E("🎋", "tanabata tree", "wish", "festival", "japanese"),
  E("🎃", "pumpkin", "halloween", "jack o lantern"),
  E("🎄", "christmas tree", "holiday", "xmas", "festive"),
  E("🎆", "fireworks", "celebration", "new year", "sparkle"),
  E("🎇", "sparkler", "fireworks", "celebration", "light"),
  E("🧨", "firecracker", "explosive", "celebration", "dynamite"),
  E("🎐", "wind chime", "chime", "decoration"),
  E("🎑", "moon viewing", "ceremony", "moon", "festival"),
  E("🪅", "pinata", "party", "celebration", "candy"),
  E("🎀", "ribbon", "bow", "gift", "wrap"),
  E("🔮", "crystal ball", "fortune", "predict", "future", "magic"),
  E("🪄", "magic wand", "magic", "wizard", "create"),
  E("🧿", "nazar", "amulet", "evil eye", "protect"),
  E("🪬", "hamsa", "hand", "protect", "amulet"),

  // ===== NATURE & WEATHER =====
  E("☀️", "sun", "sunny", "weather", "bright", "day"),
  E("🌤️", "sun behind cloud", "partly cloudy", "weather"),
  E("⛅", "sun behind cloud", "cloudy", "weather"),
  E("🌥️", "sun behind large cloud", "cloudy", "weather"),
  E("☁️", "cloud", "cloudy", "weather", "sky"),
  E("🌦️", "sun behind rain cloud", "rain", "weather"),
  E("🌧️", "cloud with rain", "rain", "weather", "rainy"),
  E("⛈️", "cloud with lightning and rain", "storm", "thunder", "weather"),
  E("🌩️", "cloud with lightning", "lightning", "storm", "weather"),
  E("🌨️", "cloud with snow", "snow", "winter", "weather"),
  E("❄️", "snowflake", "snow", "winter", "cold"),
  E("☃️", "snowman", "snow", "winter", "cold"),
  E("⛄", "snowman", "snow", "winter"),
  E("🌬️", "wind", "blow", "weather", "air"),
  E("💨", "dash", "wind", "fast", "speed", "air"),
  E("🌪️", "tornado", "cyclone", "storm", "weather"),
  E("🌫️", "fog", "mist", "weather"),
  E("🌈", "rainbow", "color", "weather", "pride"),
  E("☔", "umbrella with rain", "rain", "wet", "weather"),
  E("🌂", "closed umbrella", "rain", "weather"),
  E("☂️", "umbrella", "rain", "weather"),
  E("🌊", "wave", "water", "ocean", "sea", "surf"),
  E("💧", "droplet", "water", "drop", "rain"),
  E("💦", "sweat droplets", "water", "splash", "wet"),
  E("🔥", "fire", "flame", "hot", "burn"),
  E("🌍", "globe", "earth", "world", "planet"),
  E("🌱", "seedling", "plant", "grow", "sprout", "growth"),
  E("🌲", "evergreen", "tree", "pine", "nature"),
  E("🌳", "deciduous tree", "tree", "nature"),
  E("🌴", "palm tree", "tropical", "beach", "tree"),
  E("🌵", "cactus", "desert", "plant"),
  E("🌾", "sheaf of rice", "grain", "harvest", "plant"),
  E("🌿", "herb", "leaf", "plant", "green"),
  E("☘️", "shamrock", "clover", "luck", "irish"),
  E("🍀", "four leaf clover", "luck", "lucky", "clover"),
  E("🍁", "maple leaf", "fall", "autumn", "canada"),
  E("🍂", "fallen leaf", "autumn", "fall", "leaf"),
  E("🍃", "leaf fluttering", "wind", "leaf", "nature"),
  E("🌺", "hibiscus", "flower", "tropical"),
  E("🌸", "cherry blossom", "flower", "spring", "sakura"),
  E("🌼", "blossom", "flower", "daisy"),
  E("🌻", "sunflower", "flower", "sun", "yellow"),
  E("🌹", "rose", "flower", "red", "love"),
  E("🌷", "tulip", "flower", "spring"),
  E("💐", "bouquet", "flowers", "gift"),

  // ===== FOOD (for hospitality / cafe topics) =====
  E("🍎", "apple", "fruit", "red", "food", "health"),
  E("🍏", "green apple", "fruit", "food", "health"),
  E("🍊", "tangerine", "orange", "fruit", "food"),
  E("🍋", "lemon", "fruit", "citrus", "food"),
  E("🍌", "banana", "fruit", "food"),
  E("🍉", "watermelon", "fruit", "food", "summer"),
  E("🍇", "grapes", "fruit", "food", "wine"),
  E("🍓", "strawberry", "fruit", "berry", "food"),
  E("🫐", "blueberries", "berry", "fruit", "food"),
  E("🍈", "melon", "fruit", "food"),
  E("🍒", "cherries", "fruit", "food"),
  E("🍑", "peach", "fruit", "food"),
  E("🥭", "mango", "fruit", "tropical", "food"),
  E("🍍", "pineapple", "fruit", "tropical", "food"),
  E("🥝", "kiwi", "fruit", "food"),
  E("🍅", "tomato", "vegetable", "food", "red"),
  E("🥑", "avocado", "fruit", "food", "healthy"),
  E("🥦", "broccoli", "vegetable", "food", "healthy", "green"),
  E("🥬", "leafy green", "lettuce", "vegetable", "salad", "food"),
  E("🥒", "cucumber", "vegetable", "food"),
  E("🌶️", "hot pepper", "chili", "spicy", "food"),
  E("🌽", "corn", "maize", "vegetable", "food"),
  E("🥕", "carrot", "vegetable", "food", "orange"),
  E("🧄", "garlic", "vegetable", "food", "ingredient"),
  E("🧅", "onion", "vegetable", "food", "ingredient"),
  E("🥔", "potato", "vegetable", "food"),
  E("🍞", "bread", "loaf", "food", "bakery"),
  E("🥐", "croissant", "bread", "pastry", "bakery", "french"),
  E("🥖", "baguette", "bread", "french", "bakery"),
  E("🥨", "pretzel", "snack", "food"),
  E("🧀", "cheese", "dairy", "food"),
  E("🥚", "egg", "food", "breakfast"),
  E("🍳", "cooking", "fried egg", "breakfast", "food"),
  E("🥞", "pancakes", "breakfast", "food"),
  E("🧇", "waffle", "breakfast", "food"),
  E("🥓", "bacon", "breakfast", "food", "meat"),
  E("🥩", "cut of meat", "steak", "meat", "food"),
  E("🍗", "poultry leg", "chicken", "meat", "food"),
  E("🍖", "meat on bone", "meat", "food"),
  E("🌭", "hot dog", "food", "sausage"),
  E("🍔", "hamburger", "burger", "food", "fast food"),
  E("🍟", "french fries", "fries", "food", "fast food"),
  E("🍕", "pizza", "food", "slice", "italian"),
  E("🌮", "taco", "mexican", "food"),
  E("🌯", "burrito", "mexican", "food", "wrap"),
  E("🥙", "stuffed flatbread", "gyro", "food", "wrap"),
  E("🧆", "falafel", "food", "mediterranean"),
  E("🥗", "green salad", "salad", "healthy", "food"),
  E("🍝", "spaghetti", "pasta", "italian", "food"),
  E("🍜", "ramen", "noodles", "soup", "food", "asian"),
  E("🍲", "pot of food", "stew", "soup", "food"),
  E("🍛", "curry", "rice", "food", "asian"),
  E("🍣", "sushi", "japanese", "food", "fish"),
  E("🍱", "bento", "box", "japanese", "food", "lunch"),
  E("🥟", "dumpling", "food", "asian"),
  E("🍤", "fried shrimp", "tempura", "food", "seafood"),
  E("🍙", "rice ball", "onigiri", "japanese", "food"),
  E("🍚", "cooked rice", "rice", "food", "asian"),
  E("🍘", "rice cracker", "snack", "japanese", "food"),
  E("🍥", "fish cake", "narutomaki", "japanese", "food"),
  E("🥠", "fortune cookie", "food", "asian", "fortune"),
  E("🥮", "moon cake", "food", "chinese", "festival"),
  E("🍢", "oden", "skewer", "japanese", "food"),
  E("🍡", "dango", "skewer", "japanese", "dessert"),
  E("🍧", "shaved ice", "dessert", "ice", "sweet"),
  E("🍨", "ice cream", "dessert", "sweet", "cold"),
  E("🍦", "soft ice cream", "dessert", "sweet", "cone"),
  E("🥧", "pie", "dessert", "baked", "food"),
  E("🧁", "cupcake", "dessert", "sweet", "baked"),
  E("🍰", "shortcake", "cake", "dessert", "sweet"),
  E("🎂", "birthday cake", "cake", "celebration", "dessert"),
  E("🍮", "custard", "pudding", "dessert", "sweet"),
  E("🍭", "lollipop", "candy", "sweet", "dessert"),
  E("🍬", "candy", "sweet", "dessert"),
  E("🍫", "chocolate", "bar", "sweet", "dessert"),
  E("🍿", "popcorn", "snack", "movie", "food"),
  E("🍩", "doughnut", "donut", "dessert", "sweet"),
  E("🍪", "cookie", "dessert", "sweet", "baked"),
  E("🥛", "glass of milk", "milk", "dairy", "drink"),
  E("🍼", "baby bottle", "milk", "drink"),
  E("🧃", "juice box", "drink", "juice", "beverage"),
  E("🧉", "mate", "drink", "tea", "south america"),
  E("🍵", "tea", "teacup", "drink", "green tea"),
  E("☕", "coffee", "hot", "drink", "caffeine", "morning"),

  // ===== HEARTS & SYMBOLS =====
  E("❤️", "red heart", "love", "like", "heart"),
  E("🧡", "orange heart", "love", "heart"),
  E("💛", "yellow heart", "love", "heart"),
  E("💚", "green heart", "love", "heart", "eco"),
  E("💙", "blue heart", "love", "heart", "trust"),
  E("💜", "purple heart", "love", "heart"),
  E("🖤", "black heart", "love", "heart", "dark"),
  E("🤍", "white heart", "love", "heart", "pure"),
  E("🤎", "brown heart", "love", "heart"),
  E("💔", "broken heart", "sad", "heartbreak"),
  E("❣️", "heart exclamation", "love", "emphasis"),
  E("💕", "two hearts", "love", "hearts"),
  E("💞", "revolving hearts", "love", "hearts"),
  E("💓", "beating heart", "love", "heart", "alive"),
  E("💗", "growing heart", "love", "heart"),
  E("💖", "sparkling heart", "love", "heart", "special"),
  E("💘", "heart with arrow", "love", "cupid", "valentine"),
  E("💝", "heart with ribbon", "love", "gift", "valentine"),
  E("💟", "heart decoration", "love", "heart"),
  E("☮️", "peace", "symbol", "harmony"),
  E("✝️", "cross", "christian", "religion"),
  E("☪️", "star and crescent", "islam", "religion"),
  E("🕉️", "om", "hindu", "religion", "symbol"),
  E("☸️", "dharma wheel", "buddhism", "religion"),
  E("✡️", "star of david", "judaism", "religion"),
  E("☯️", "yin yang", "balance", "harmony", "symbol"),
  E("🕎", "menorah", "judaism", "religion", "hanukkah"),
  E("♻️", "recycle", "recycling", "eco", "green", "environment"),
  E("⚜️", "fleur de lis", "symbol", "france"),
  E("🔱", "trident", "emblem", "poseidon"),
  E("📛", "name badge", "badge", "id", "identification"),
  E("🔰", "japanese symbol for beginner", "beginner", "shoshinsha"),
  E("⭕", "circle", "correct", "o", "ring"),
  E("✅", "check", "green", "done", "correct"),
  E("☑️", "check box", "checked", "vote", "done"),
  E("✔️", "check mark", "tick", "done"),
  E("❎", "cross mark", "x", "no"),
  E("➰", "curly loop", "loop", "curl"),
  E("➿", "double curly loop", "loop", "curl"),
  E("〽️", "part alternation mark", "symbol"),
  E("✳️", "eight spoked asterisk", "asterisk", "star"),
  E("✴️", "eight pointed star", "star", "sparkle"),
  E("❇️", "sparkle", "sparkles", "star"),
  E("©️", "copyright", "c", "legal", "symbol"),
  E("®️", "registered", "r", "trademark", "legal"),
  E("™️", "trade mark", "tm", "trademark", "legal"),
  E("#️⃣", "hash", "number", "pound", "hashtag"),
  E("*️⃣", "asterisk", "star", "keypad"),
  E("0️⃣", "zero", "number", "0"),
  E("1️⃣", "one", "number", "1"),
  E("2️⃣", "two", "number", "2"),
  E("3️⃣", "three", "number", "3"),
  E("4️⃣", "four", "number", "4"),
  E("5️⃣", "five", "number", "5"),
  E("6️⃣", "six", "number", "6"),
  E("7️⃣", "seven", "number", "7"),
  E("8️⃣", "eight", "number", "8"),
  E("9️⃣", "nine", "number", "9"),
  E("🔟", "ten", "number", "10"),
  E("🔠", "uppercase", "letters", "abc", "latin"),
  E("🔡", "lowercase", "letters", "abc", "latin"),
  E("🔢", "numbers", "1234", "digits"),
  E("🔣", "symbols", "input", "characters"),
  E("🔤", "abc", "letters", "latin", "alphabet"),
  E("🅰️", "a button", "blood type", "a"),
  E("🆎", "ab button", "blood type", "ab"),
  E("🅱️", "b button", "blood type", "b"),
  E("🆑", "cl button", "clear"),
  E("🆒", "cool button", "cool"),
  E("🆓", "free button", "free"),
  E("ℹ️", "information", "info", "i"),
  E("🆔", "id button", "identity", "identification"),
  E("Ⓜ️", "circled m", "m", "metro"),
  E("🆕", "new button", "new"),
  E("🆖", "ng button", "no good"),
  E("🅾️", "o button", "blood type", "o"),
  E("🆗", "ok button", "ok", "okay"),
  E("🅿️", "p button", "parking"),
  E("🆘", "sos", "help", "emergency", "distress"),
  E("🆙", "up button", "up"),
  E("🆚", "vs button", "versus", "against"),
  E("🈁", "japanese here", "koko", "here"),
  E("🈶", "japanese not free of charge", "not free", "charge"),
  E("🈯", "japanese reserved", "reserved", "pointing"),
  E("🉐", "japanese bargain", "bargain", "discount"),
  E("🈹", "japanese discount", "discount", "sale"),
  E("🈚", "japanese free of charge", "free", "no charge"),
  E("🈲", "japanese prohibited", "prohibited", "forbidden"),
  E("🉑", "japanese acceptable", "acceptable", "ok"),
  E("🈸", "japanese application", "application", "apply"),
  E("🈴", "japanese passing grade", "passing", "pass"),
  E("🈳", "japanese vacancy", "vacancy", "available", "empty"),
  E("㊗️", "japanese congratulations", "congratulations", "congrats"),
  E("㊙️", "japanese secret", "secret", "confidential"),
  E("🈺", "japanese open for business", "open", "business"),

  // ===== ARROWS & SHAPES =====
  E("⬆️", "up arrow", "up", "direction", "arrow"),
  E("↗️", "up right arrow", "northeast", "direction"),
  E("➡️", "right arrow", "right", "direction", "next"),
  E("↘️", "down right arrow", "southeast", "direction"),
  E("⬇️", "down arrow", "down", "direction"),
  E("↙️", "down left arrow", "southwest", "direction"),
  E("⬅️", "left arrow", "left", "direction", "back", "previous"),
  E("↖️", "up left arrow", "northwest", "direction"),
  E("↕️", "up down arrow", "vertical", "direction"),
  E("↔️", "left right arrow", "horizontal", "direction"),
  E("↩️", "right arrow curving left", "reply", "undo", "back"),
  E("↪️", "left arrow curving right", "forward", "share"),
  E("⤴️", "right arrow curving up", "up", "share"),
  E("⤵️", "right arrow curving down", "down"),
  E("🔃", "clockwise arrows", "refresh", "reload", "sync"),
  E("🔄", "counterclockwise arrows", "refresh", "reload", "sync", "repeat"),
  E("🔀", "shuffle", "random", "shuffle tracks"),
  E("🔁", "repeat", "loop", "repeat button"),
  E("🔂", "repeat single", "repeat one", "loop once"),
  E("▶️", "play", "play button", "start"),
  E("⏩", "fast forward", "next", "forward"),
  E("⏭️", "next track", "skip", "next"),
  E("⏯️", "play or pause", "play pause"),
  E("◀️", "reverse", "back", "reverse button"),
  E("⏪", "rewind", "fast reverse", "back"),
  E("⏮️", "previous track", "last", "previous"),
  E("🔼", "up button", "up", "upwards"),
  E("⏫", "fast up", "up", "double up"),
  E("🔽", "down button", "down", "downwards"),
  E("⏬", "fast down", "down", "double down"),
  E("⏸️", "pause", "pause button", "stop"),
  E("⏹️", "stop", "stop button", "square"),
  E("⏺️", "record", "record button", "circle"),
  E("⏏️", "eject", "eject button"),
  E("🎦", "cinema", "movie", "film", "camera"),
  E("🔅", "dim", "low brightness", "brightness"),
  E("🔆", "bright", "high brightness", "brightness"),
  E("📶", "signal", "antenna bars", "signal strength", "bars"),
  E("📳", "vibration", "vibrate", "phone mode"),
  E("📴", "mobile off", "phone off", "silent"),
  E("♾️", "infinity", "infinite", "forever", "loop", "unlimited"),
  E("🔶", "orange diamond", "diamond", "shape"),
  E("🔷", "blue diamond", "diamond", "shape"),
  E("🔸", "small orange diamond", "diamond", "shape"),
  E("🔹", "small blue diamond", "diamond", "shape"),
  E("🔺", "red triangle up", "triangle", "up", "shape"),
  E("🔻", "red triangle down", "triangle", "down", "shape"),
  E("💠", "diamond with dot", "diamond", "shape", "kawaii"),
  E("🔘", "radio button", "button", "circle", "select"),
  E("🔳", "white square button", "square", "button"),
  E("🔲", "black square button", "square", "button"),
  E("▪️", "black small square", "square", "shape"),
  E("▫️", "white small square", "square", "shape"),
  E("◾", "black medium small square", "square", "shape"),
  E("◽", "white medium small square", "square", "shape"),
  E("◼️", "black medium square", "square", "shape"),
  E("◻️", "white medium square", "square", "shape"),
  E("🟥", "red square", "square", "red", "shape"),
  E("🟧", "orange square", "square", "orange", "shape"),
  E("🟨", "yellow square", "square", "yellow", "shape"),
  E("🟩", "green square", "square", "green", "shape"),
  E("🟦", "blue square", "square", "blue", "shape"),
  E("🟪", "purple square", "square", "purple", "shape"),
  E("⬛", "black large square", "square", "black", "shape"),
  E("⬜", "white large square", "square", "white", "shape"),
  E("🟫", "brown square", "square", "brown", "shape"),
  E("🔴", "red circle", "circle", "red", "shape"),
  E("🟠", "orange circle", "circle", "orange", "shape"),
  E("🟡", "yellow circle", "circle", "yellow", "shape"),
  E("🟢", "green circle", "circle", "green", "shape", "go", "active"),
  E("🔵", "blue circle", "circle", "blue", "shape"),
  E("🟣", "purple circle", "circle", "purple", "shape"),
  E("⚫", "black circle", "circle", "black", "shape"),
  E("⚪", "white circle", "circle", "white", "shape"),
  E("🟤", "brown circle", "circle", "brown", "shape"),
  E("🔶", "large orange diamond", "diamond", "orange"),
  E("🔷", "large blue diamond", "diamond", "blue"),
];

export default businessEmojis;
